import React from "react";
import { useTranslation, Trans } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles(theme => ({
  paper: {
    marginBottom: theme.spacing(6),
    marginTop: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(3)
    }
  },
  root: {
    paddingBottom: theme.spacing(6),
    paddingTop: theme.spacing(6),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    lineHeight: "1.5",
    margin: "0 auto",
    maxWidth: "900px",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  container: {
    marginBottom: theme.spacing(2)
  },
  list: {
    padding: theme.spacing(2),
    "& > li": {
      marginBottom: theme.spacing(2)
    }
  },
  footer: {
    textAlign: "right"
  }
}));

function Welcome() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Paper className={classes.paper}>
      <div className={classes.root}>
        <h2>{t("welcome.title")}</h2>
        <div>{t("welcome.text")}</div>
        <ul className={classes.list}>
          <li>
            <Trans i18nKey={"welcome.list.1"}>
              text <b>text</b> text
            </Trans>
          </li>
          <li>
            <Trans i18nKey={"welcome.list.2"}>
              text <b>text</b> text
            </Trans>
          </li>
          <li>
            <Trans i18nKey={"welcome.list.3"}>
              text <b>text</b> text
            </Trans>
          </li>
          <li>
            <Trans i18nKey={"welcome.list.4"}>
              text <b>text</b> text
            </Trans>
          </li>
          <li>
            <Trans i18nKey={"welcome.list.5"}>
              text <b>text</b> text
            </Trans>
          </li>
          <li>
            <Trans i18nKey={"welcome.list.6"}>
              text <b>text</b> text
            </Trans>
          </li>
        </ul>
        <div className={classes.footer}>{t("welcome.footer")}</div>
      </div>
    </Paper>
  );
}

export default Welcome;
